import React, { useState } from 'react';
import { ArrowRightIcon, XIcon } from 'lucide-react';
import { BlockMark } from './Logo';
const BAR_TEXTURE = 'https://cdn.magicpatterns.com/patterns/generated-images/364f5f76-c9ff-4999-a5b1-60b818ee5dff.jpg';
export function AnnouncementBar() {
  const [open, setOpen] = useState(true);
  if (!open) return null;
  return <div className="relative bg-night bg-cover bg-center text-white" style={{
    backgroundImage: `url(${BAR_TEXTURE})`
  }} data-id="element-27" data-mp="euqphk0z0vjw">
      <div className="px-4 md:px-6" data-id="element-28" data-mp="5ukcs0d3jzls">
        <div className="mx-auto flex h-10 max-w-[1360px] items-center px-5 pr-12 md:px-6" data-id="element-29" data-mp="5tj4g3ngtr7r">
          <a href="#contact" className="group flex min-w-0 items-center gap-2.5 font-mono text-[12px] font-medium uppercase tracking-[0.06em] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white" data-id="element-30" data-mp="wahlprdgz06">
            <BlockMark className="h-[11px] w-auto shrink-0" data-id="element-31" data-mp="1qa5wzhqt35t9" />
            <span className="truncate" data-id="element-32" data-mp="1qap1nwrg3xpc">Freie Kapazitäten für Projekte in Q1 2027</span>
            <span className="grid h-[18px] w-[18px] shrink-0 place-items-center bg-ink text-white transition-transform duration-150 ease-out group-hover:translate-x-0.5" data-id="element-33" data-mp="67gx1mg7r9y9">
              <ArrowRightIcon className="h-3 w-3" data-id="element-34" data-mp="3sfzys3i91mbd" />
            </span>
          </a>
        </div>
      </div>
      <button type="button" onClick={() => setOpen(false)} aria-label="Hinweis schließen" className="absolute right-3 top-1/2 grid h-7 w-7 -translate-y-1/2 place-items-center text-white/80 transition-colors duration-150 hover:text-white focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-white md:right-5" data-id="element-35" data-mp="18dqtyohyxop">
        <XIcon className="h-4 w-4" data-id="element-36" data-mp="f73wi2pdu5oo" />
      </button>
    </div>;
}